/**
 * Chart tile configuration. Values marked (Phase 0) must be confirmed against
 * Kartverket's WMTS GetCapabilities on the reference devices (spec 01).
 */

// Client always talks to our same-origin proxy so the service worker can cache
// tiles (spec 01 / PLAN tile-proxy rationale). `?v=` busts on new chart editions.
export const TILE_URL = '/tiles/{z}/{x}/{y}.png?v=1';

// Kartverket sjøkartraster (webmercator matrix). maxNativeZoom (Phase 0) — beyond
// it Leaflet overzooms existing tiles ("zoom in without new data") for free.
export const TILE_OPTIONS = {
  maxZoom: 18,
  maxNativeZoom: 18,
  minZoom: 3,
  updateWhenIdle: true, // old-GPU mercy: don't re-tile mid-pan
  keepBuffer: 4,
  detectRetina: false,
  attribution: '© Kartverket',
} as const;

// Alternative base charts via the proxy (upstream configured server-side).
export const SKIPPO_URL = '/base/skippo/{z}/{x}/{y}.png?v=1';
// v=2: busts tiles cached while ENC upstream was misconfigured to the raster WMS.
export const ENC_URL = '/base/enc/{z}/{x}/{y}.png?v=2';

// Free OpenSeaMap seamark symbol overlay (buoys, lights, beacons).
export const SEAMARK_URL = '/seamark/{z}/{x}/{y}.png?v=1';
export const SEAMARK_OPTIONS = {
  minZoom: 8,
  maxNativeZoom: 18,
  maxZoom: 18,
  updateWhenIdle: true,
  detectRetina: false,
  pane: 'depthPane',
  className: 'depth-layer',
} as const;

// Free Kartverket depth-data overlay (contours + soundings + shallows). Only
// meaningful zoomed in, so no low zooms; overzoom past 15 keeps it readable.
export const DEPTH_URL = '/depth/{z}/{x}/{y}.png?v=1';
export const DEPTH_OPTIONS = {
  minZoom: 8,
  maxNativeZoom: 18,
  maxZoom: 18,
  updateWhenIdle: true,
  detectRetina: false,
  opacity: 0.9,
  pane: 'depthPane',
  className: 'depth-layer',
} as const;

// Default view: Ballstad, Lofoten (until the first GPS fix or follow tap).
export const DEFAULT_CENTER: [number, number] = [68.06, 13.56];
export const DEFAULT_ZOOM = 14;
